import { all, call } from "redux-saga/effects";
import { watchGetDataPermission } from "./menuRoleSaga";
import { watchDeleteDataUserMenu, watchGetDataUserMenu, watchSetDataUserMenu } from "./userMenuSaga";

export default function* rootUserMenuSaga() {
    yield all([
        call(watchGetDataPermission),
        call(watchGetDataUserMenu),
        call(watchDeleteDataUserMenu),
        call(watchSetDataUserMenu),
        //IndexUsingHygen
    ])
}